<template>
  <div>
    <!-- Отображаем очищенное сообщение -->
    <div v-html="sanitizeAndFormatMessage(fullMessage)"></div>
  </div>
</template>

<script>
import DOMPurify from 'dompurify';

export default {
  name: "detailedViewMail",
  props: {
    fullMessage: {
      type: String,
      required: true
    }
  },
  methods: {
    sanitizeAndFormatMessage(message) {
      if (message) {
        // Заменяем \r\n и \n на <br> для сохранения формата текста
        const formattedMessage = message.replace(/(\r\n|\n)/g, '<br>');

        // Очищаем сообщение с помощью DOMPurify
        return DOMPurify.sanitize(formattedMessage);
      }
      return message; // Если нет текста, возвращаем пустое сообщение
    }
  }
}
</script>

<style scoped>
/* Стили для отображения текста в модальном окне */
div {
  font-family: Arial, sans-serif;
  font-size: 14px;
  line-height: 1.6;
}
</style>